import * as creationServiceActions from 'redux/middleware/api/creation-service/actions';
import { VideoZipRequestArgs } from 'redux/middleware/api/creation-service/types';
import { ThunkAction } from 'redux/types';

import reduxPoll from 'utils/redux-poll';
import { cancelPolling } from '../common/actions';
import { showNotification } from '../notification';
import { Type } from './action-types';
import { VIDEO_ZIP_REQUEST_POLL_ID } from './constants';
import { currentVideoZipRequestStatusSelector } from './selectors';

export const createVideoZipRequest = (
  args: VideoZipRequestArgs,
): ThunkAction<Promise<any>> => async dispatch => {
  dispatch({
    type: Type.CREATE_VIDEO_ZIP_REQUEST,
  });

  try {
    const { response } = await dispatch(
      creationServiceActions.createVideoZipRequest(args),
    );

    dispatch({
      type: Type.CREATE_VIDEO_ZIP_REQUEST_SUCCESS,
      payload: {
        zipRequestId: response.result,
      },
    });

    return response;
  } catch (error) {
    dispatch({
      type: Type.CREATE_VIDEO_ZIP_REQUEST_FAILURE,
    });

    throw error;
  }
};

export const getVideoZipRequest = (
  args: VideoZipRequestArgs,
): ThunkAction<Promise<any>> => async dispatch => {
  dispatch({
    type: Type.GET_VIDEO_ZIP_REQUEST,
  });

  try {
    const { response } = await dispatch(
      creationServiceActions.getVideoZipRequest(args),
    );

    dispatch({
      type: Type.GET_VIDEO_ZIP_REQUEST_SUCCESS,
      payload: {
        zipRequestId: response.result,
      },
    });

    return response;
  } catch (error) {
    dispatch({
      type: Type.GET_VIDEO_ZIP_REQUEST_FAILURE,
    });

    throw error;
  }
};

export const resetVideoZipRequestState = () => ({
  type: Type.RESET_VIDEO_ZIP_REQUEST_STATE,
});

export const pollForVideoZipRequest = (
  args: VideoZipRequestArgs,
): ThunkAction<Promise<void>> => async (dispatch, getState) => {
  await reduxPoll(
    dispatch,
    async () => {
      const response = await dispatch(getVideoZipRequest(args));

      return response;
    },
    {
      id: VIDEO_ZIP_REQUEST_POLL_ID,
      shouldContinue: error => {
        const status = currentVideoZipRequestStatusSelector(getState());

        if (error || status === 'failed') {
          dispatch(
            showNotification({
              message: 'Failed to export clips. Please try again.',
              level: 'error',
              type: 'help',
            }),
          );

          return false;
        }

        return status !== 'completed';
      },
      intervalMillis: 2500,
      maxAttempts: Infinity,
    },
  );
};

export const cancelVideoZipRequestPolling = (): ThunkAction<void> => dispatch =>
  dispatch(cancelPolling(VIDEO_ZIP_REQUEST_POLL_ID));
